import HttpService from "./httpService";

export class OrderService {


    static getOrderById = async (orderId: string) => {
        return HttpService.get<any>(`/orders/${orderId}`);
    }

    static getOrderStats = () => {
        return HttpService.get<any>('/orders/stats');
    }

    static getPendingPaymentOrders = () => {
        return HttpService.get('/order/pending-payments');
    }

    static getAdminOrders = (status: string) => {
        if (status === 'ALL') {
            return HttpService.get<any[]>('/orders');
        }
        return HttpService.get<any[]>('/orders?status=' + status);
    }

    static verifyPayment = async (orderId: string) => {
        return HttpService.post(`/orders/${orderId}/verify-payment`, {});
    }

    static updateOrderStatus = async (
        orderId: string, 
        status: string, 
        shippingDetails?: { 
            trackingUrl?: string; 
            expectedDeliveryDate?: string 
        }
    ) => {
        const payload: any = { status };
        
        // Add shipping details if provided and status is SHIPPED
        if (status === 'SHIPPED' && shippingDetails) {
            if (shippingDetails.trackingUrl) {
                payload.trackingUrl = shippingDetails.trackingUrl;
            }
            if (shippingDetails.expectedDeliveryDate) {
                payload.expectedDeliveryDate = shippingDetails.expectedDeliveryDate;
            }
        }
        
        return HttpService.post(`/orders/${orderId}/status`, payload);
    }



    static getAdminOrderItems = async (status?: string) => {
        return HttpService.get<any[]>(`/order-items?status=${status}`)
    }


    static getRecentOrders = async () => {
        return HttpService.get<any[]>(`/orders/recent`)
    }

    static updateExpectedDeliveryDate = async (orderId: string, expectedDeliveryDate: string) => {
        return HttpService.post(`/orders/${orderId}/expected-delivery-date`, { expectedDeliveryDate });
    }


}